import { TYPES_USER_ROLES } from 'utils/constants'

export const GTM_SEARCH_PARAMS_KEYS = {
  CHILD: 'child',
  UTM_CAMPAIGN: 'utm_campaign',
  UTM_MEDIUM: 'utm_medium',
  UTM_SOURCE: 'utm_source',
}
const setGtmLDataLayer = ({ event, role, userId }) => {
  const roles = Array.isArray(role) ? role.toString() : role
  const users = Array.isArray(userId) ? userId.toString() : userId
  let { dataLayer } = window
  dataLayer = dataLayer || []
  dataLayer.push({
    event: event.toLowerCase(),
    role_type: roles.toLowerCase(),
    user_id: users.toLowerCase(),
  })
}

export const handleEventsToGtm = ({
  isValidated = true,
  role,
  studentId,
  userId,
}) => {
  setGtmLDataLayer({ event: 'user_login', role, userId })
  if (!isValidated) {
    setGtmLDataLayer({
      event: `confirmation_${role}`,
      role: role,
      userId: userId,
    })
    if (studentId) {
      setGtmLDataLayer({
        event: `confirmation_${TYPES_USER_ROLES.STUDENT}`,
        role: [TYPES_USER_ROLES.STUDENT, role],
        userId: [studentId, userId],
      })
    }
  }
}
